import { Navigate, createBrowserRouter } from "react-router-dom";

/**ADMIN ROUTE START */
import AdminLayout from "./modules/admin/shared/adminlayout";
import Login from "./modules/admin/pages/login";
import PrivateRoute from "./modules/admin/shared/privateRoute";
import PublicRoute from "./modules/admin/shared/publicRoute";
import Profile from "./modules/admin/pages/profile";
import EditProfile from "./modules/admin/pages/editprofile";
import Changepassword from "./modules/admin/pages/changepassword";
import OtpVerificationPage from "./modules/admin/pages/otpverification";
import ForgotPwdPage from "./modules/admin/pages/forgotpassword";
import ResetPwdPage from "./modules/admin/pages/resetpwd";
import Error404 from "./modules/admin/pages/404";
import Dashboard from "./modules/admin/pages/dashboard";
import EmailTemplatesTable from "./modules/admin/pages/cms/automaticemailtemplates/list";
import EmailTempAdd from "./modules/admin/pages/cms/automaticemailtemplates/add";
import EmailTempEdit from "./modules/admin/pages/cms/automaticemailtemplates/edit";
import ViewEmailTemp from "./modules/admin/pages/cms/automaticemailtemplates/view";
import GlobalSettings from "./modules/admin/pages/cms/settings/settings";
import UsersTable from "./modules/admin/pages/usermgmt/list";
import UsersView from "./modules/admin/pages/usermgmt/view";
import UsersAdd from "./modules/admin/pages/usermgmt/add";
import UserEdit from "./modules/admin/pages/usermgmt/edit";
import DoctorList from "./modules/admin/pages/doctors/list";
import DoctorAdd from "./modules/admin/pages/doctors/add";
import DoctorView from "./modules/admin/pages/doctors/view";
import DoctorEdit from "./modules/admin/pages/doctors/edit";
import AdminUnAuthLayout from "./modules/admin/shared/adminUnAuthLayout";
import GlobalLayout from "./modules/GlobalLayout";
import PageAdd from "./modules/admin/pages/cms/pages/add";
import PageEdit from "./modules/admin/pages/cms/pages/edit";
import PageTable from "./modules/admin/pages/cms/pages/list";
import PageView from "./modules/admin/pages/cms/pages/view";
import FAQView from "./modules/admin/pages/cms/faq/view";
import FAQTable from "./modules/admin/pages/cms/faq/list";
import FAQAdd from "./modules/admin/pages/cms/faq/add";
import FAQEdit from "./modules/admin/pages/cms/faq/edit";

/** ----------------- CENTER --------------- */
// import CenterPrivateRoute from "./modules/center/shared/centerPrivateRoute";
// import CenterPublicRoute from "./modules/center/shared/publicRoute";
// import Verifyotp from "./modules/center/pages/auth/verifyotp";
// import CenterLayout from "./modules/center/shared/centerLayout";
// import CenterAuthLayout from "./modules/center/shared/centerAuthLayout";
// import CenterForgotPwdPage from "./modules/center/pages/auth/forgot_password";
// import CenterLogin from "./modules/center/pages/auth/login";
// import CenterResetPassword from "./modules/center/pages/auth/resetPassword";
// import SelectUser from "./modules/center/pages/auth/selectUser";
// import Page404 from "./modules/center/404Page/page404";
// import CenterDashboard from "./modules/center/pages/dashboard/CenterDashboard";
// import Doctor from "./modules/center/pages/settings/Doctor";
// import Schedule from "./modules/center/pages/settings/Schedule";
// import Wallet from "./modules/center/pages/settings/Wallet";


// import DoctorAuthLayout from "./modules/doctor/shared/doctorAuthLayout";
// import DoctorPrivateRoute from "./modules/doctor/shared/doctorPrivateRoute";
// import DoctorMyProfile from "./modules/doctor/pages/profile/pages/DoctorMyProfile";
// import DoctorLayout from "./modules/doctor/shared/doctorLayout";
// import CenterProfile from "./modules/center/pages/profile/CenterProfile";
// import CenterProfileChangePassword from "./modules/center/pages/profile/ProfileChangePassword";
// import Patients from "./modules/center/pages/settings/Patient";
// import Appointment from "./modules/center/pages/settings/Appointment";
// import DoctorDashboard from "./modules/doctor/pages/dashboard/DoctorDashboard";
// import Patient from "./modules/doctor/pages/settings/patient";
// import DoctorProfileChangePassword from "./modules/doctor/pages/profile/pages/ProfileChangePassword";
// import PatientAppointment from "./modules/doctor/pages/settings/Appointment";
// import ConsultationHistory from "./modules/doctor/pages/settings/consulationHistory";
// import PatientView from "./modules/doctor/pages/settings/viewPatient";
// import MedicalHistoryView from "./modules/doctor/pages/settings/medicalHistoryView";
// import ConsultationHistoryView from "./modules/doctor/pages/settings/viewConsulationHistroy";
// import ConsultationMedicalHistoryView from "./modules/doctor/pages/settings/consulationMedicalHistory";
// import PrescriptionCreate from "./modules/doctor/pages/settings/PrescriptionCreate";
// import PrescriptionEdit from "./modules/doctor/pages/settings/PrescriptionEdit";
// import CenterPatientView from "./modules/center/pages/settings/viewPatient";
// import CenterDoctorPrivateRoute from "./modules/doctor/centerDoctorPrivateRoute";



import WebsiteLayout from "./modules/website/shared/layout";
import WebsiteHomePage from "./modules/website/pages/homePage";
import WebsiteAboutUs from "./modules/website/pages/aboutUs";
// import WebsitePrivacyPolicy from "./modules/website/pages/privacyPolicy";
import Faq from "./modules/website/pages/Faq";
import DynamicWebPage from "./modules/website/pages/DynamicPage";
import WebsiteTerms from "./modules/website/pages/terms";
import InquiryTable from "./modules/admin/pages/inquiry/list";
import ViewInquiry from "./modules/admin/pages/inquiry/view";
import WebsiteInquiry from "./modules/website/common/inquiry";
import StaffAdd from "./modules/admin/pages/staff/add";
import StaffTable from "./modules/admin/pages/staff/list";
import StaffEdit from "./modules/admin/pages/staff/edit";
import StaffView from "./modules/admin/pages/staff/view";
import AppointmentAdd from "./modules/admin/pages/appointments/add";
import AppointmentTable from "./modules/admin/pages/appointments/list";
import AppointmentEdit from "./modules/admin/pages/appointments/edit";
import AppointmentView from "./modules/admin/pages/appointments/view";
import PermissionsTable from "./modules/admin/permissions/list";
// import WebsiteHelpSupport from "./modules/website/pages/help&Support";
import PatientTables from "./modules/admin/pages/customerManagement/list";
import PatientAdd from "./modules/admin/pages/customerManagement/add";
import ViewPatient from "./modules/admin/pages/customerManagement/view";
import PatientEdit from "./modules/admin/pages/customerManagement/edit";
import VideoTable from "./modules/admin/pages/cms/video/list";
import VideoAdd from "./modules/admin/pages/cms/video/add";
import VideoEdit from "./modules/admin/pages/cms/video/edit";
import VideoView from "./modules/admin/pages/cms/video/view";
import ReportView from "./modules/admin/pages/reports/reports";
import PatientReportTables from "./modules/admin/pages/reports/patientReport";
import MedicineReportTable from "./modules/admin/pages/reports/medicineReprt";
import EarningReportTable from "./modules/admin/pages/reports/earningReport";
// import PrescriptionView from "./modules/doctor/pages/settings/PrescriptionView";
import CustomerTables from "./modules/admin/pages/customerManagement/list";
import CustomerAdd from "./modules/admin/pages/customerManagement/add";
import CustomerEdit from "./modules/admin/pages/customerManagement/edit";
import ViewCustomer from "./modules/admin/pages/customerManagement/view";
import CoachSpecializationTable from "./modules/admin/pages/coachSpecialization/list";
import CoachSpecializationView from "./modules/admin/pages/coachSpecialization/view";
import AddCoachSpecialization from "./modules/admin/pages/coachSpecialization/add";
import CoachSpecializationEdit from "./modules/admin/pages/coachSpecialization/edit";
import CoachTable from "./modules/admin/pages/coach/list";
import CoachView from "./modules/admin/pages/coach/view";
import CoachEdit from "./modules/admin/pages/coach/edit";
import Page404 from "./modules/website/pages/Page404";
import AddCoach from "./modules/admin/pages/coach/add";
import SupplementTable from "./modules/admin/pages/supplement/list";
import AddSupplement from "./modules/admin/pages/supplement/add";
import EditSupplement from "./modules/admin/pages/supplement/edit";
import SupplementView from "./modules/admin/pages/supplement/view";
import DynamicPages from "./modules/website/pages/DynamicPage";
// import PatientDietChart from "./modules/doctor/pages/settings/patientDietChart";


const router = createBrowserRouter([


    {
    path: "/",
    element: <WebsiteLayout />,
    children: [
      {
        path: "",
        element: <WebsiteHomePage />,
      },
      {
        path: ":slug",
        element: <DynamicPages />,
      }
    ],
  },

  // {
  //   path: "/", element: <GlobalLayout />,
  //   children: [

      /** Pages for website start >>>>  */
      {
        path: "/",
        element: <WebsiteLayout />,
        children: [
          { path: "", element: <WebsiteHomePage /> },
          // { path: "/about-us", element: <WebsiteAboutUs /> },
          // { path: "/contact-us", element: <WebsiteContactUs /> },
          // { path: "/privacy-policy", element: <WebsitePrivacyPolicy /> },
          // { path: "/terms-conditions", element: <WebsiteTerms /> },
          // { path: "/help-support", element: <WebsiteHelpSupport /> },
          // { path: "/faq", element: <Faq /> },
          // { path: "/inquiry", element: <WebsiteInquiry /> },
          // { path: "/:slug", element: <DynamicWebPage /> },
          { path: "*", element: <Page404 /> },
        ],
      },
      /** Pages for website end <<<<  */

      /**ADMIN ROUTE START */
      {
        path: "admin",
        element: <PrivateRoute component={AdminLayout} />,
        children: [
          {
            path: "",
            element: <Navigate to={"/admin/dashboard/1"} />,
          },
          {
            path: "dashboard/:pgno",
            element: <PrivateRoute component={Dashboard} />,
          },
          {
            path: "profile",
            element: <PrivateRoute component={Profile} />,
            children: [
              {
                path: "edit/:id",
                element: <PrivateRoute component={EditProfile} />,
              },
              {
                path: "change-password/:id",
                element: <PrivateRoute component={Changepassword} />,
              },
            ],
          },

          {
            /** Centre Management Route Start */
          },
          {
            path: "center-management/center/list/:pgno",
            element: <PrivateRoute component={UsersTable} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/add",
            element: <PrivateRoute component={UsersAdd}  requiredPermission="center_management"/>,
          },
          {
            path: "center-management/center/:pgno/edit/:id",
            element: <PrivateRoute component={UserEdit} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/view/:id",
            element: <PrivateRoute component={UsersView} requiredPermission="center_management" />,
          },
          {
            /** Centre Management Route End */
          },
          {
            /** Patient Management Route Start */
          },
          {
            path: "customer-management/customer/list/:pgno",
            element: <PrivateRoute component={CustomerTables} requiredPermission="patient_management" />,
          },
          {
            path: "customer-management/customer/add",
            element: <PrivateRoute component={CustomerAdd} requiredPermission="patient_management" />,
          },
          {
            path: "customer-management/customer/:pgno/edit/:id",
            element: <PrivateRoute component={CustomerEdit} requiredPermission="patient_management" />,
          },
          {
            path: "customer-management/customer/view/:id",
            element: <PrivateRoute component={ViewCustomer} requiredPermission="patient_management" />,
          },
          {
            /** Patient Management Route End */
          },
          {
            /** Staff  Route Start */
          },
          {
            path: "staff/list/:pgno",
            element: <PrivateRoute component={StaffTable} requiredPermission="staff_management"/>,
          },
          {
            path: "staff/add",
            element: <PrivateRoute component={StaffAdd} requiredPermission="staff_management" />,
          },
          {
            path: "staff/:pgno/edit/:id",
            element: <PrivateRoute component={StaffEdit} requiredPermission="staff_management" />,
          },
          {
            path: "staff/view/:id",
            element: <PrivateRoute component={StaffView} requiredPermission="staff_management" />,
          },
          {
          /** Staff  Route End */
          },
          {
          /** Appointment  Route Start */
          },
          {
            path: "appointment/list/:pgno",
            element: <PrivateRoute component={AppointmentTable} requiredPermission="appointment_management" />,
          },
          {
            path: "appointment/add",
            element: <PrivateRoute component={AppointmentAdd} requiredPermission="appointment_management" />,
          },
          {
            path: "appointment/:pgno/edit/:id",
            element: <PrivateRoute component={AppointmentEdit} requiredPermission="appointment_management"/>,
          },
          {
            path: "appointment/view/:id",
            element: <PrivateRoute component={AppointmentView} requiredPermission="appointment_management" />,
          },
          {
          /** Appointment  Route End */
          },
          /** CMS Route Start */
          {
            path: "cms/pages/list/:pgno",
            element: <PrivateRoute component={PageTable} requiredPermission="cms_page"  />,
          },
          {
            path: "cms/pages/add",
            element: <PrivateRoute component={PageAdd} requiredPermission="cms_page"  />,
          },
          {
            path: "cms/pages/:pgno/edit/:id",
            element: <PrivateRoute component={PageEdit} requiredPermission="cms_page"  />,
          },
          {
            path: "cms/pages/view/:id",
            element: <PrivateRoute component={PageView}  requiredPermission="cms_page" />,
          },
          // {
          //   path: "cms/faq/list/:pgno",
          //   element: <PrivateRoute component={FAQTable}  requiredPermission="faq" />,
          // },
          // {
          //   path: "cms/faq/add",
          //   element: <PrivateRoute component={FAQAdd}  requiredPermission="faq" />,
          // },
          // {
          //   path: "cms/faq/:pgno/edit/:id",
          //   element: <PrivateRoute component={FAQEdit}   requiredPermission="faq" />,
          // },
          // {
          //   path: "cms/faq/view/:id",
          //   element: <PrivateRoute component={FAQView}  requiredPermission="faq" />,
          // },
          {
            path: "cms/video/list/:pgno",
            element: <PrivateRoute component={VideoTable}  requiredPermission="video" />,
          },
          {
            path: "cms/video/add",
            element: <PrivateRoute component={VideoAdd}   requiredPermission="video"/>,
          },
          {
            path: "cms/video/:pgno/edit/:id",
            element: <PrivateRoute component={VideoEdit}  requiredPermission="video" />,
          },
          {
            path: "cms/video/view/:id",
            element: <PrivateRoute component={VideoView}   requiredPermission="video"/>,
          },
          /** CMS Route End */
          {
            path: "inquiries/list/:pgno",
            element: <PrivateRoute component={InquiryTable}  requiredPermission="inquires" />,
          },
          {
            path: "inquiries/view/:id",
            element: <PrivateRoute component={ViewInquiry}  requiredPermission="inquires" />,
          },
          {
            path: "permissions/add/:id",
            element: <PrivateRoute component={PermissionsTable}/>,
          },
          {
            /** Doctor Management Route Start */
          },
          {
            path: "doctor-management/doctor/list/:pgno",
            element: <PrivateRoute component={DoctorList} requiredPermission="doctor_management" />,
          },
          {
            path: "doctor-management/doctor/add",
            element: <PrivateRoute component={DoctorAdd} requiredPermission="doctor_management" />,
          },
          {
            path: "doctor-management/doctor/view/:id",
            element: <PrivateRoute component={DoctorView}  requiredPermission="doctor_management"/>,
          },
          {
            path: "doctor-management/doctor/:pgno/edit/:id",
            element: <PrivateRoute component={DoctorEdit} requiredPermission="doctor_management" />,
          },
          {
          /** Doctor Management Route End */
            /** Patient Management Route Start */
          },
          {
            /** Patient Management Route End */
          },
          /** Supplement Management Route Start */
          {
            path: "supplement-management/list/:pgno",
            element: <PrivateRoute component={SupplementTable} requiredPermission="supplement-management" />,
          },
          {
            path: "supplement-management/add",
            element: <PrivateRoute component={AddSupplement} requiredPermission="supplement-management" />,
          },
          {
            path: "supplement-management/:pgno/edit/:id",
            element: <PrivateRoute component={EditSupplement} requiredPermission="supplement-management" />,
          },
          {
            path: "supplement-management/view/:id",
            element: <PrivateRoute component={SupplementView} requiredPermission="supplement-management" />,
          },
          {
            /** Medicine Management Route End */
          },


           /** Coach Management Route Start */
          {
            path: "coach-management/add",
            element: <PrivateRoute component={AddCoach} requiredPermission="coach_management" />,
          },
          {
            path: "coach-management/list/:pgno",
            element: <PrivateRoute component={CoachTable} requiredPermission="coach_management" />,
          },
          {
            path: "coach-management/view/:id",
            element: <PrivateRoute component={CoachView} requiredPermission="coach_management" />,
          },
          {
            path: "coach-management/:pgno/edit/:id",
            element: <PrivateRoute component={CoachEdit}  requiredPermission="coach_management"/>,
          },
          {
            /** Coach Management Route End */
          },

          {
            /**Email Template Management Route Start */
          },
          {
            path: "email-template/list/:pgno",
            element: <PrivateRoute component={EmailTemplatesTable} requiredPermission="email_template" />,
          },
          {
            path: "email-template/view/:id",
            element: <PrivateRoute component={ViewEmailTemp} requiredPermission="email_template" />,
          },
          {
            path: "email-template/add",
            element: <PrivateRoute component={EmailTempAdd}  requiredPermission="email_template"/>,
          },
          {
            path: "email-template/:pgno/edit/:id",
            element: <PrivateRoute component={EmailTempEdit} requiredPermission="email_template" />,
          },
          {
            /**Email Template Management Route End */
          },

          {
            path: "coach-specialization/list/:pgno",
            element: <PrivateRoute component={CoachSpecializationTable} requiredPermission="coach-specialization" />,
          },
          {
            path: "coach-specialization/view/:id",
            element: <PrivateRoute component={CoachSpecializationView} requiredPermission="coach-specialization" />,
          },
          {
            path: "coach-specialization/add",
            element: <PrivateRoute component={AddCoachSpecialization}  requiredPermission="coach-specialization"/>,
          },
          {
            path: "coach-specialization/:pgno/edit/:id",
            element: <PrivateRoute component={CoachSpecializationEdit} requiredPermission="coach-specialization" />,
          },

          /**General Settings Route Start */
          {
            path: "general-settings",
            element: <PrivateRoute component={GlobalSettings} requiredPermission="general_settings" />,
          },
          /**General Settings Route End */

          /** Reports Route Start */
          {
            path: "report-management",
            element: <PrivateRoute component={ReportView} requiredPermission="report-management" />,
            children: [
              {
                path: "customer/list/:pgno",
                element: <PrivateRoute component={PatientReportTables} requiredPermission="report-management" />,
              },
              {
                path: "supplement/list/:pgno",
                element: <PrivateRoute component={MedicineReportTable} requiredPermission="report-management" />,
              },
              {
                path: "earning-report/list/:pgno",
                element: <PrivateRoute component={EarningReportTable} requiredPermission="report-management" />,
              },
            ],
          }        
        /** Reports Route Start */
        ],
      },
      {
        path: "admin",
        element: <AdminUnAuthLayout />,
        children: [
          { path: "login", element: <PublicRoute component={Login} /> },
          {
            path: "forget-password",
            element: <PublicRoute component={ForgotPwdPage} />,
          },
          {
            path: "otp-verification/:email",
            element: <PublicRoute component={OtpVerificationPage} />,
          },
          {
            path: "reset-password",
            // element: localStorage.getItem("validate_string") ? <PrivateRoute component={ResetPwdPage} /> : <Navigate to="/admin/login" />
            element: <PublicRoute component={ResetPwdPage} />,
          },
        ],
      },

      { path: "admin/*", element: <Error404 /> },
      /**ADMIN ROUTE END */

      // { path: "*", element: <Page404 homePath="/" /> },
    // ],

  // },


  // /** CENTER ROUTE START */
  // {
  //   path: "center",
  //   element: <CenterPrivateRoute component={CenterLayout} />,
  //   children: [
  //     {
  //       path: "",
  //       element: <Navigate to={"/center/dashboard/:page"} />,
  //     },
  //     {
  //       path: "dashboard/:page",
  //       element: <CenterPrivateRoute component={CenterDashboard} />,
  //     },
  //     {
  //       path: "profile",
  //       children: [
  //         {
  //           path: "",
  //           element: <CenterPrivateRoute component={CenterProfile} />,
  //         },
  //         {
  //           path: "change-password",
  //           element: (
  //             <CenterPrivateRoute component={CenterProfileChangePassword} />
  //           ),
  //         },
  //       ],
  //     },
  //     {
  //       path: "settings/doctor/:page",
  //       element: <CenterPrivateRoute component={Doctor} />,
  //     },
  //     {
  //       path: `settings/doctor/schedule/:page`,
  //       element: <CenterPrivateRoute component={Schedule} />,
  //     },
  //     {
  //       path: `patient/:page`,
  //       element: <CenterPrivateRoute component={Patients} />,
  //     },
  //     {
  //       path: `patient/appointment/:page`,
  //       element: <CenterPrivateRoute component={Appointment} />,
  //     },
  //     {
  //       path: `patient/appointment/view/:id`,
  //       element: <CenterPrivateRoute component={CenterPatientView} />,
  //     },
  //     {
  //       path: "patient/medical-history/view",
  //       element: <CenterDoctorPrivateRoute component={MedicalHistoryView} />,
  //     },
  //     {
  //       path: "wallet/:page",
  //       element: <CenterPrivateRoute component={Wallet} />,
  //     },
  //     { path: "*", element: <Page404 homePath="/center/dashboard/1" /> },
  //   ],
  // },
  // /** CENTER ROUTE END */

  // {
  //   path: "select-user",
  //   element: <SelectUser />
  // },

  // /** CENTER AUTH ROUTE START */
  // {
  //   path: "center",
  //   element: <CenterPublicRoute component={CenterAuthLayout} />,
  //   children: [
  //     {
  //       path: "",
  //       element: <Navigate to={"/center/dashboard/1"} />
  //     },
  //     {
  //       path: "login",
  //       element: <CenterPublicRoute component={CenterLogin} />,
  //     },
  //     {
  //       path: "forget-password",
  //       element: <CenterPublicRoute component={CenterForgotPwdPage} />,
  //     },
  //     {
  //       path: "reset-password",
  //       element: <CenterPublicRoute component={CenterResetPassword} />,
  //     },
  //     {
  //       path: "otp-verification",
  //       element: <CenterPublicRoute component={Verifyotp} />,
  //     },
  //     { path: "*", element: <Page404 homePath="/center" /> },
  //   ],
  // },

  // /** DOCTOR ROUTE START */
  // {
  //   path: "doctor",
  //   element: <DoctorPrivateRoute component={DoctorLayout} />,
  //   children: [
  //     {
  //       path: "",
  //       element: <Navigate to={"/doctor/dashboard/:page"} />,
  //     },
  //     {
  //       path: "dashboard/:page",
  //       element: <DoctorPrivateRoute component={DoctorDashboard} />,
  //     },
  //     {
  //       path: "profile",
  //       children: [
  //         {
  //           path: "",
  //           element: <DoctorPrivateRoute component={DoctorMyProfile} />,
  //         },
  //         {
  //           path: "change-password",
  //           element: (
  //             <DoctorPrivateRoute component={DoctorProfileChangePassword} />
  //           ),
  //         },
  //       ],
  //     },
  //     {
  //       path: "settings/patient/:page",
  //       // element: <Patient />,
  //       element: (
  //         <DoctorPrivateRoute component={Patient} />
  //       ),
  //     },
  //     // {
  //     //   path: `patient/appointment/:page`,
  //     //   element: <DoctorPrivateRoute component={PatientAppointment} />,
  //     // },
  //     {
  //       path: "patient/appointment/:page",
  //       element: <DoctorPrivateRoute component={PatientAppointment} />,
  //     },
  //     {
  //       path: "patient/appointment/view/:id",
  //       element: <DoctorPrivateRoute component={PatientView} />,
  //     },
  //     {
  //       path: "patient/medical-history/view",
  //       element: <CenterDoctorPrivateRoute component={MedicalHistoryView} />,
  //     },
  //     {
  //       path: "consultation-history/:page",
  //       element: <DoctorPrivateRoute component={ConsultationHistory} />,
  //     },
  //     {
  //       path: "consultation-history/view/:id",
  //       element: <DoctorPrivateRoute component={ConsultationHistoryView} />,
  //     },
  //     {
  //       path: "consultation/medical-history/view",
  //       element: <DoctorPrivateRoute component={ConsultationMedicalHistoryView} />,
  //     },
  //     {
  //       path: "consultation/prescription/add",
  //       element: <DoctorPrivateRoute component={PrescriptionCreate} />,
  //     },
  //     {
  //       path: "consultation/prescription/edit/:id",
  //       element: <DoctorPrivateRoute component={PrescriptionEdit} />,
  //     },
  //     {
  //       path: "consultation/prescription/view/:id",
  //       element: <DoctorPrivateRoute component={PrescriptionView} />,
  //     },
  //     {
  //       path: "patient/diet-chart/add",
  //       element: <DoctorPrivateRoute component={PatientDietChart} />,
  //     },
  //     { path: "*", element: <Page404 homePath="/doctor/dashboard" /> },
  //   ],
  // },
  // /** DOCTOR ROUTE END */

  // /** DOCTOR AUTH ROUTE START */
  // {
  //   path: "doctor",
  //   element: <CenterPublicRoute component={DoctorAuthLayout} />,
  //   children: [
  //     {
  //       path: "",
  //       element: <Navigate to={"/doctor/dashboard"} />
  //     },
  //     {
  //       path: "login",
  //       element: <CenterPublicRoute component={CenterLogin} />,
  //     },
  //     {
  //       path: "forget-password",
  //       element: <CenterPublicRoute component={CenterForgotPwdPage} />,
  //     },
  //     {
  //       path: "reset-password",
  //       element: <CenterPublicRoute component={CenterResetPassword} />,
  //     },
  //     {
  //       path: "otp-verification",
  //       element: <CenterPublicRoute component={Verifyotp} />,
  //     },
  //     { path: "*", element: <Page404 homePath="/doctor" /> },
  //   ],
  // },
]);

export default router;
